import * as React from "react";
import { graphql } from "gatsby";

//Components
import Layout from "../components/layout/layout";
import Block from "../components/dynamic";

//Interfaces
import { IPage } from "../utilities/query-interfaces";

interface IPageTemplateProps {
  data: {
    contentfulPage: IPage;
  };
}

export default function PageTemplate(props: IPageTemplateProps) {
  const page = props.data.contentfulPage;
  
  
  let pageComponents: React.ReactNode[] = [];

  if (page.components && page.components.length) {
    pageComponents = page.components.map((content, index) => {
      if (content.internal && content.internal.type) {
        const type = content.internal.type.replace("Contentful", "");

        return (
          <Block data={content} type={type} key={index} isFirstBlock={index === 0} />
        );
      } else {
        // Unknown data, return nothing
        return null;
      }
    });
  }

  return (
    <Layout
      description={page.description ? page.description.description : ""}
      path={page.path}
      title={page.title}
    >
      {pageComponents}
    </Layout>
  );
}

export const pageQuery = graphql`
  query ContentfulPageByPath($urlPath: String!) {
    contentfulPage(path: { eq: $urlPath }) {
      ...PageData
    }
  }
`;
